import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { FileText, Trash2, Edit2 } from "lucide-react";
import { api, imageUrl } from "@/lib/api";
import { CATEGORIES } from "@/lib/constants";

export function DraftsTab({ drafts, reload, L, lang }) {
  const navigate = useNavigate();
  const del = async (id) => {
    if (!window.confirm(L("حذف المسودة؟", "Delete this draft?"))) return;
    await api.delete(`/drafts/${id}`).catch(() => {});
    toast.success(L("تم حذف المسودة", "Draft deleted")); reload();
  };
  if (!drafts.length) return <div className="text-center py-20 text-slate-500" data-testid="no-drafts"><FileText className="w-12 h-12 mx-auto mb-3 text-slate-300" />{L("لا توجد مسودات محفوظة", "No saved drafts")}</div>;
  return (
    <div className="space-y-3" data-testid="drafts-list">
      {drafts.map((d) => {
        const f = d.data || {};
        const cat = CATEGORIES.find((c) => c.id === f.catId);
        const sub = cat?.subcategories.find((s) => s.id === f.subId);
        return (
          <div key={d.id} className="bg-white rounded-2xl border border-[#EFEBE0] p-3 flex items-center gap-3" data-testid={`draft-${d.id}`}>
            <span className="w-16 h-16 rounded-xl overflow-hidden bg-[#F4F2EC] shrink-0 flex items-center justify-center">
              {f.images?.[0] ? <img src={imageUrl(f.images[0])} alt="" className="w-full h-full object-cover" /> : <FileText className="w-6 h-6 text-slate-300" />}
            </span>
            <span className="flex-1 min-w-0">
              <span className="block font-bold truncate">{f.title || L("بدون عنوان", "Untitled")}</span>
              <span className="block text-xs text-slate-500 truncate">{[cat && (lang === "en" ? cat.name_en : cat.name_ar), sub && (lang === "en" ? sub.name_en : sub.name_ar)].filter(Boolean).join(" · ")}</span>
              <span className="block text-[11px] text-slate-400">{d.updated_at && new Date(d.updated_at).toLocaleString(lang === "ar" ? "ar-AE-u-nu-latn" : "en-AE")}</span>
            </span>
            <button onClick={() => navigate(`/post?draft=${d.id}`)} className="h-9 px-3 rounded-xl bg-[#1A5C3A] text-white text-sm font-bold flex items-center gap-1" data-testid={`draft-continue-${d.id}`}><Edit2 className="w-4 h-4" />{L("متابعة", "Continue")}</button>
            <button onClick={() => del(d.id)} className="h-9 w-9 rounded-xl border border-red-200 text-red-600 flex items-center justify-center" data-testid={`draft-delete-${d.id}`}><Trash2 className="w-4 h-4" /></button>
          </div>
        );
      })}
    </div>
  );
}
